<template>
  <v-card-text>
    <v-row align="center">
      <v-col cols="12" sm="4">
        <h2 class="azul f-30 header-space ml-1 medium-font title-custom">Support</h2>
      </v-col>
    </v-row>
    <v-alert v-if="status==='success'" type="success">
      Your message has been successfully sent to us
    </v-alert>
    <v-alert v-if="status==='error'" type="error">
      Your message has not been sent, please try again
    </v-alert>
    <v-form ref="support_form" class="pl-1 labels-medium inputs-gray form-support">
      <ValidationObserver ref="validator" v-slot="{}">
        <div class="container-form">
          <v-row align="center">
            <v-col cols="12" sm="4">
              <keep-alive>
                <ValidationProvider
                    mode="passive"
                    ref="firstName"
                    rules="required"
                    v-slot="{ errors }"
                >
                  <v-text-field
                      v-model="fullName"
                      :error-messages="errors"
                      class="ui-label label-font-16 change_bord especial_border support-input custom-input-position-text"
                      label="Full Name"
                      type="text"
                      width="660px"
                      required
                  ></v-text-field>
                </ValidationProvider>
              </keep-alive>
            </v-col>
            <v-col cols="12" sm="4">
              <keep-alive>
                <ValidationProvider
                    mode="passive"
                    ref="lastName"
                    rules="required|size:10"
                    v-slot="{ errors }"
                >
                  <v-text-field
                      v-model="phoneNumber"
                      :error-messages="errors"
                      v-mask="mask"
                      class="ui-label label-font-16 change_bord especial_border support-input custom-input-position-text"
                      label="Cell Phone Number"
                      type="text"
                      width="660px"
                      required
                  ></v-text-field>
                </ValidationProvider>
              </keep-alive>
            </v-col>
            <v-col cols="12" sm="4">
              <keep-alive>
                <ValidationProvider
                    mode="passive"
                    ref="email"
                    rules="required|email"
                    v-slot="{ errors }"
                >
                  <v-text-field
                      v-model="email"
                      :error-messages="errors"
                      class="ui-label label-font-16 change_bord especial_border support-input custom-input-position-text"
                      label="Email"
                      name="email"
                      type="text"
                      width="660px"
                      required
                  ></v-text-field>
                </ValidationProvider>
              </keep-alive>
            </v-col>
            <v-col cols="8" sm="8" style="padding: 0px 12px;">
              <keep-alive>
                <ValidationProvider
                    mode="passive"
                    ref="companyName"
                    rules="required"
                    v-slot="{ errors }"
                >
                  <v-text-field
                      v-model="companyName"
                      :error-messages="errors"
                      class="ui-label label-font-16 change_bord especial_border support-input custom-input-position-text"
                      label="Company Name"
                      name="companyName"
                      type="text"
                      width="660px"
                      required
                  ></v-text-field>
                </ValidationProvider>
              </keep-alive>
            </v-col>


            <v-col cols="4" sm="4" style="padding: 0px 12px;">
              <keep-alive>
                <ValidationProvider
                    mode="passive"
                    ref="role"
                    rules="required"
                    v-slot="{ errors }"
                >
                  <v-select
                      v-model="role"
                      :items="roles"
                      :error-messages="errors"
                      class="ui-label label-font-16 change_bord especial_border support-input custom-input-position-text"
                      label="Role"
                      type="text"
                      width="660px"
                      item-text="name"
                      item-value="val"
                      required
                      bottom
                  ></v-select>
                </ValidationProvider>
              </keep-alive>
            </v-col>

            <template v-if="showInvited">
              <v-col cols="8" sm="8" style="padding: 0px 12px;">
                <keep-alive>
                  <ValidationProvider
                      mode="passive"
                      ref="invited"
                      rules="required"
                      v-slot="{ errors }"
                  >
                    <v-text-field
                        v-model="invited"
                        :error-messages="errors"
                        class="ui-label label-font-16 change_bord especial_border support-input custom-input-position-text"
                        label="Which agent invited you to Kiey? "
                        type="text"
                        width="660px"
                        required
                    ></v-text-field>
                  </ValidationProvider>
                </keep-alive>
              </v-col>
            </template>

            <v-col cols="12" sm="12" style="padding: 15px 12px;">
              <keep-alive>
                <ValidationProvider
                    mode="passive"
                    ref="help"
                    rules="required"
                    v-slot="{ errors }"
                >
                  <div class="ui-label mb-2">
                    <label class="title-how-help">How can we help you?</label>
                  </div>

                  <v-textarea
                      v-model="help"
                      :error-messages="errors"
                      class="ui-label change_bord especial_border support-input custom-input-position-text"
                      name="help"
                      width="660px"
                      outlined
                      rows="3"
                      row-height="25"
                  ></v-textarea>
                </ValidationProvider>
              </keep-alive>
            </v-col>
            <v-col cols="12" sm="12" style="padding: 15px 12px;">
              <keep-alive>
                <ValidationProvider
                    ref="picture" rules=""
                    v-slot="{ errors }"
                >
                  <Upload
                      :error-messages="errors"
                      accept="image/png, image/jpeg, image/jpg"
                      placeholder="Picture"
                      prepend-icon="fas fa-camera"
                      label=""
                      :multiple="false"
                      :onSelectedVideo="onSelectedPicture"
                  ></Upload>
                </ValidationProvider>
              </keep-alive>
            </v-col>
          </v-row>
          <v-img style="background: lightgrey" v-if="picture" width="200" height="200" contain :src="picture"></v-img>


          <div v-if="imageData !== null && !picture"
               style="width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;">
            <v-img
                width="50" height="50" contain
                :src="require('@/assets/document.svg')"
            >
            </v-img>
            <label class="mt-5" v-if="imageData">{{ imageData.name }}</label>
          </div>
        </div>
      </ValidationObserver>
    </v-form>
    <div class="text-center">
      <v-btn
          :loading="status==='loading'"
          :disabled="status==='loading'"
          depressed
          rounded
          class="ml-6 btn-azul"
          style="margin-top: 15px; height: 48px!important;"
          @click="submit"
      >SUBMIT
      </v-btn>
    </div>
  </v-card-text>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from "vuex";
  import {mask} from "vue-the-mask";
  import Upload from "@/components/UploadWithCrop"
  import {loadImageFromVideo, loadImageFromPdf, isVideo, isImage, isPdf, uploadFileToStorage} from "@/util/video_utils_v2";

  export default {
    name: "Support",
    props: {
      onSubmitted: {
        type: Function,
        default: () => {
        }
      }
    },
    created() {
      //
    },
    computed: {
      ...mapState({
        status: state => state.Support.status,
      })
    },
    directives: {
      mask,
    },
    data: () => ({
      imageData: null,
      urlData: null,
      picture: null,
      showInvited: false,
      mask: "### - ### - ####",
      fullName: "",
      phoneNumber: "",
      email: "",
      companyName: "",
      help: "",
      role: "",
      invited: "",
      roles: [
        {id: "Agent Owner", name: "Agent (Owner)"},
        {id: "Agent Team Member", name: "Agent (Team Member)"},
        {id: "Vendor Owner", name: "Vendor (Owner)"},
        {id: "Vendor Employee", name: "Vendor (Employee)"},
        {id: "Client", name: "Homeowner"},
      ]
    }),
    components: {
      ValidationProvider,
      ValidationObserver,
      Upload
    },
    watch: {
      role(val) {
        if (["Client", "Vendor (Owner)", "Vendor (Employee)"].includes(val)) {

          this.showInvited = true;
        } else {
          this.showInvited = false;
          this.invited = "";
        }
      }
    },
    methods: {
      async submit() {
        const self = this;
        const valid = await self.$refs.validator.validate();

        if (valid) {

          if (self.imageData) {
            await self.uploadToStorage();
          }
          self.saveData();
        }
      },
      saveData() {
        const self = this;
        self.$store
          .dispatch("Support/send_mail", {
            fullName: self.fullName,
            phoneNumber: self.phoneNumber,
            email: self.email,
            companyName: self.companyName,
            help: self.help,
            role: self.role,
            invited: self.invited,
            file_url: self.urlData,
            file_name: self.imageData ? self.imageData.name : "",
          })
          .then((response) => {
            if (response.status === 200) {
              setTimeout(() => {
                self.$store.commit("Support/status", '');
                self.onSubmitted();
              }, 3000);
            }
            self.$refs.support_form.reset();
          })
          .catch(function (error) {
            console.error(error);
          });
      },
      async onSelectedPicture(file, source) {
        const self = this;
        self.imageData = file;
        self.urlData = null;

        const fileTmp = {
          url: file.name
        };
        if (isImage(fileTmp)) {
          self.picture = source;
        } else if (isVideo(fileTmp)) {
          self.picture = await loadImageFromVideo(source);
        } else if (isPdf(fileTmp)) {
          self.picture = await loadImageFromPdf(source);
        } else {
          self.picture = "";
        }
      }
      ,
      async uploadToStorage() {
        const self = this;
        self.$store.commit("Support/status", 'loading');
        if (!self.imageData.name) {
          self.imageData.name = new Date().getTime().toString();
        }
        const url = await uploadFileToStorage(self.imageData, 'support');
        self.picture = url;
        self.urlData = url;
      }
      ,
    }
  };
</script>

<style scoped lang="scss">
  .owner-suport {
    .custom-input-position-text input {
      margin: 8px 0px;
    }

    .custom-container {
      max-width: 1222px !important;
      min-height: 632px;
      top: 30px;
      margin-bottom: 50px !important;
      padding: 20px 62px 50px 62px;
    }

    .summary-label {
      color: #061d47;
      font-size: 15.5px;
      margin-top: 1rem;
    }

    .alert-login-vendor h3 {
      font-size: 22px;
      margin: 3px 0px 0.24rem 13px;
    }

    .alert-login-vendor p {
      font-size: 14px;
      margin: 0 0 7px 13px;
      letter-spacing: 1.34px;
    }

    .summary-value {
      color: #3c5fa9;
      font-size: 18px;
    }

    .p-expansion-login {
      margin-left: 1.5rem;
      font-size: 17.2px;
      line-height: 2.13rem;
    }

    .padding-payment-inputs {
      padding-bottom: 0.2rem;
    }

    .link-check {
      color: #29abe2;
      text-decoration: none;
    }

    .ml-14 {
      margin-left: 56px;
    }

    .ml-16 {
      margin-left: 64px;
    }

    .account-information-checkbox {
      position: absolute;
      right: 0;
      top: 1rem;
    }

    .alert-value-font {
      font-size: 18px;
    }

    .small-checkbox > label {
      font-size: 14px;
    }

    /* number color to list in modal-box */
    li.number-color {
      color: #29abe2;
    }

    li.number-color > a {
      cursor: default;
    }

    .medium-font {
      font-weight: 500 !important;
    }

    textarea {
      height: 115px !important;
      min-height: 115px !important;
    }

    .title-how-help {
      font-size: 16px !important;
      font-weight: 700;
      line-height: 14px !important;
    }

    .title-custom {
      margin: 12px 0 5px 0;
      margin-left: 0 !important;
    }

    .container-form {
      margin: 35px auto 0;
    }

    .form-support {
      padding-left: 0 !important;
    }

    @media (max-width: 960px) {
      .alert-login-vendor h3 {
        font-size: 16px;
      }
      .alert-login-vendor p {
        font-size: 13px;
      }
      .p-expansion-login {
        margin-left: auto;
        font-size: 12px;
      }
      .ml-14 {
        margin-left: auto;
      }
      .ml-16 {
        margin-left: auto;
      }
    }

    @media (max-width: 1400px) {
      .account-information-checkbox {
        position: absolute;
        right: unset;
        top: 2.5rem;
      }
    }
    @media (max-width: 600px) {
      .title-how-help {
        font-size: 14px !important;
      }
    }
  }
</style>
